import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// GET ALL 
export const GetAllProfile = createAsyncThunk(
    "masters/profile/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Masters.Profile}?user=${filter?.user || ""}&pf_id=${filter?.pf_id || ""}
                &country=${filter?.country || ""}&profile=${filter?.profile || ""}
                &profile_image=${filter?.profile_image || ""}
                &page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`
            );
            return res;
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

//GET SINGLE
export const GetProfile = createAsyncThunk(
    "masters/profile/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.getUser}/${id}`);
            console.log(res," response for user ");
            return res;
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



//CREATE
export const AddProfile = createAsyncThunk(
    "masters/profile/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(APIS.Masters.Profile, data);

            console.log("profile data", res);

            return res;
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



// UPDATE
export const UpdateProfile = createAsyncThunk(
    "masters/profile/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(
                `${APIS.Masters.Profile}/${id}`,
                data   // send FormData 
            );
            return res;
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

//DELETE 
export const DeleteProfile = createAsyncThunk(
    "masters/profile/delete",
    async (id, { rejectWithValue }) => {
        try {
            await DELETE(`${APIS.Masters.Profile}/${id}`);
            return id;
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// STATUS
export const StatusProfile = createAsyncThunk(
    "masters/profile/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Masters.Profile}/${id}`);
            return res;
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "profile",
    initialState: {
        data: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
         user: {},
    },
 
    reducers: {},
    extraReducers: (builder) => {
        builder

            // GET ALL 
            .addCase(GetAllProfile.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllProfile.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllProfile.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            // GET SINGLE
            .addCase(GetProfile.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetProfile.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.user = action.payload?.data || action.payload;
            })
            .addCase(GetProfile.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            //CREATE 
            .addCase(AddProfile.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(AddProfile.fulfilled, (state) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                //state.data.unshift(action.payload?.data);
            })
            .addCase(AddProfile.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            //UPDATE
            .addCase(UpdateProfile.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(UpdateProfile.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;

                const updated = action.payload?.data;

                const index = state.data.findIndex(
                    (item) => item.id === updated?.id
                );

                if (index !== -1) {
                    state.data[index] = updated;
                }
            })
            .addCase(UpdateProfile.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            //DELETE
            .addCase(DeleteProfile.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(DeleteProfile.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = state.data.filter(
                    (item) => item.id !== action.payload
                );
            })
            .addCase(DeleteProfile.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            //STATUS
            .addCase(StatusProfile.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(StatusProfile.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;

                const updated = action.payload?.data;

                const index = state.data.findIndex(
                    (item) => item.id === updated?.id
                );

                if (index !== -1) {
                    state.data[index] = updated;
                }
            })
            .addCase(StatusProfile.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

export default Slice.reducer;
